import { redirect } from "../utility"

export function pageStart() {
    //all links
    /*
    $('a:not(a[href*="#"], .no-loading)').on('click', function (event) {
        event.preventDefault();
        let href = $(this).attr('href');

        if(href) {
            loading(true);

            setTimeout(() => {
                return redirect(href);
            }, 200);
        }
    });
    */
}

export function loading(status) {
    let $pageLoader =  $('.page-loader')

    if(status) {
        $pageLoader.removeClass('animated fadeOut')
        $pageLoader.addClass('is-active')
        $pageLoader.addClass('animated fadeIn')
    } else {
        $pageLoader.removeClass('is-active')
        $pageLoader.removeClass('animated fadeIn')
        $pageLoader.addClass('animated fadeOut')
    }
}